class ProviderRegistry {
  constructor() {
    this.providers = new Map()
  }

  register(provider) {
    if (!provider || !provider.id) {
      throw new Error('Provider must include an id')
    }
    this.providers.set(provider.id, provider)
    return provider
  }

  unregister(id) {
    if (!id) return false
    return this.providers.delete(id)
  }

  get(id) {
    return this.providers.get(id) || null
  }

  list({ versionId = null, type = null } = {}) {
    let list = Array.from(this.providers.values())
    if (type) list = list.filter((p) => p.id === type)
    if (versionId) {
      list = list.filter((p) => {
        if (!p.versions || p.versions.length === 0) return true
        return p.versions.includes(versionId) || p.versions.includes('*')
      })
    }
    return list
  }

  async search(query, ctx = {}) {
    const providers = this.list({ versionId: ctx.versionId })
    const tasks = providers.map(async (p) => {
      if (typeof p.list !== 'function') return []
      try {
        const res = await p.list(query, ctx)
        return Array.isArray(res) ? res : []
      } catch {
        return []
      }
    })
    const results = (await Promise.all(tasks)).flat()
    return results
  }

  searchSync(query, ctx = {}) {
    const providers = this.list({ versionId: ctx.versionId })
    const results = []
    providers.forEach((provider) => {
      if (typeof provider.listSync !== 'function') return
      try {
        const list = provider.listSync(query, ctx)
        if (Array.isArray(list)) results.push(...list)
      } catch {
        /* noop */
      }
    })
    return results
  }

  async preload(ctx = {}) {
    const providers = this.list({ versionId: ctx.versionId })
    const tasks = providers.map(async (provider) => {
      if (typeof provider.preload !== 'function') return null
      try {
        return await provider.preload(ctx)
      } catch {
        return null
      }
    })
    await Promise.all(tasks)
  }
}

const registry = new ProviderRegistry()

export function getProviderRegistry() {
  return registry
}

export default ProviderRegistry
